








































































import Vue from "vue";
import Component from "vue-class-component";
import Datepicker from 'vuejs-datepicker';
import ErrorMessages from "@/ts/constants/FormErrorMessages";
import builder, { IVueStateCollection } from "@/ts/FormBuilder";
import { IPermitVueModel } from '@/ts/models/IPermitVueModel';

@Component({
    props: {
        form: {
            type: Object as () => IPermitVueModel
        },
        vueStates: {
            type: Object as () => IVueStateCollection
        },
        isReadOnly: {
            type: Boolean
        }
    },
    components: {
        Datepicker
    }
})
export default class RockCrushingSignature extends Vue {

    name: string = "Signature";
    title: string = "";
    index: number = NaN;
    legend: string = "";
    date: string = "";

    errorMsgs = ErrorMessages;

    mounted(): void {
        var visited = this.$props.vueStates.views[this.$props.vueStates.views.length - 1].visited;

        if (this.$props.vueStates.isRenewal && visited == false) {
            for (var i = 0; i < this.$props.form.attachments.length; i++) {
                (this.$parent as any).removeFile(this.$props.form.attachments[i].value);
            }
        }

        this.legend = builder.getFormHeader(this.$props.vueStates.formName);
        this.initializeComponent(this.name);

        if (this.$props.form.signatureDate === "0001-01-01T00:00:00") {
            this.$props.form.signatureDate = new Date();
        }

        let toDate = new Date(this.$props.form.signatureDate);
        this.date = toDate.toLocaleDateString() + " " + toDate.toLocaleTimeString();
    }

    private initializeComponent(routeName: string): void {
        this.index = builder.getIndexByVueState(this.$props.vueStates.views, routeName);
        this.title = this.$props.vueStates.views[this.index].name;

        this.$emit("update:title", this.title);
        this.$emit("update:currentIndex", this.index);

        this.$watch("hasErrors", (n, o) => {
            this.$props.vueStates.views[this.index].error = this.hasErrors;
        }, { immediate: true });

        this.$props.vueStates.views[this.index].visited = true;
    }

    // this is a bit hacky need to find a better way to persist file input across child components.
    triggerClickEvent(): void {
        // reverting to JS? sure, why not?!
        (document.getElementById("files") as HTMLElement).click();
    }

    // this is a bit hacky need to find a better way to persist file input across child components.
    deleteAttachment(fileId: string): void {
        // I'm pretty sure this isn't the correct way to do this...
        (this.$parent as any).removeFile(fileId);
    }

    get isSignatureError(): boolean {
        return this.$props.form.signature === null || this.$props.form.signature.length > 100;
    }

    get certDate(): string {
        let date = new Date(this.$props.form.certificationDate);
        return `${date.getMonth() + 1}/${date.getDate()}/${date.getFullYear()}`;
    }
    
    get isFilesError(): boolean {
        return this.$props.form.attachments.length < 1;
    }

    get hasErrors(): boolean {
        return this.isSignatureError;
    }
}

